import { createAsyncThunk } from '@reduxjs/toolkit';
import { authApi } from '@/store/api';
import { updateSessionAction } from './update-session.action';
import { requestLock } from '@/utils';
import { REFRESH_LOCK_KEY } from '@/constants';
import mixpanel from '@/configs/mixpanel';

export const refreshAction = createAsyncThunk<any, void>(
	'auth/refresh',
	async (_, { dispatch }: any) => {
		const release = await requestLock(REFRESH_LOCK_KEY);

		try {
			const result = await dispatch(
				authApi.endpoints.refresh.initiate(undefined, { track: false })
			);

			if ('error' in result) {
				console.error('Failed to update session:', result);
				throw result.error;
			}

			dispatch(updateSessionAction(result.data));
			const user = result.data?.user;
			mixpanel.track('[SESSION RESTORED]', {
				...(user?.email ? { userEmail: user.email } : {}),
				...(user?.id ? { userId: user.id } : {}),
				...(user?.full_name ? { username: user.full_name } : {}),
			});

			return result.data;
		} finally {
			release();
		}
	}
);
